<script>
  import { onMount } from 'svelte'
  import { clientStore, dataStore, scanStore, transactionStore } from '../../stores'
  import Loader from '../Loader.svelte'
  import AddClientModal from './AddClientModal.svelte'
  import ClientDetailsModal from './ClientDetailsModal.svelte'
  import { Datatable } from 'svelte-simple-datatables';
  import { settings } from '../../../scripts/datatablesSettings';
  import { config } from '../../../scripts/defaultURL';
  import { formatPhone, formatDate, openModal } from '../../../scripts/functions';
  import { getData } from '../../../scripts/rest';
  
  let initialized = false;
  let clientData = [];
  let clientItem;
  let rows;
  
  onMount(() => {
    clearValuesThenGetClients()
  });

  $: if ($clientStore && $clientStore.todo == 'getData') clearValuesThenGetClients();

  $: if (clientData) {
    if (!$dataStore) $dataStore = {};
    $dataStore['clients'] = clientData;
    initialized = true;
  }

  function clearValuesThenGetClients() {
    clientItem = null;
    if ($clientStore && $clientStore.todo) $clientStore.todo = null;
    $scanStore = {};
    $transactionStore = {};

    const url = `${config.defaultURL}/clients`;
    console.log("Fetching clients from:", url);

    getData(url).then((response) => { 
        console.log("✅ Raw API Response:", response);        // ← Check this
        console.log("Type of response:", typeof response);
        
        const clients = response?.data || response || [];
        console.log("Extracted clients array:", clients);
        console.log("Number of clients:", clients.length);

        clientData = clients.sort((a, b) => {
            if (a.last < b.last) return -1;
            if (b.last < a.last) return 1;
            return 0;
        });
    }).catch(err => {
        console.error("❌ Failed to load clients:", err);
    });
}

  function clientDetailsModal(item) {
    if (!$clientStore) $clientStore = {};
    $clientStore['client'] = item;
    clientItem = $clientStore.client;

    openModal('#clientDetailsModal');
  }
</script>

<style>
  td {
    cursor: pointer;
  }

  .flex {
    display: flex;
    justify-content: space-between;
    padding: 0.5rem;
  }
</style>

<div class="flex">
  <div class="left">
    <h3>Client List</h3>
  </div>
  <div class="right">
    <button on:click={() => { openModal('clientModal') }} class="button is-primary">
      <span class="icon">
        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M20 14H14V20H10V14H4V10H10V4H14V10H20V14Z" />
        </svg>
      </span>
      <span>Add Client</span>
    </button>
  </div>
</div>
{#if initialized}
  <Datatable settings={settings} data={clientData} bind:dataRows={rows}>
    <thead>
      <th data-key="first">First</th>
      <th data-key="last">Last</th>
      <th data-key="email">Email</th>
      <th data-key="phone">Phone</th>
      <th data-key="followup">Followup</th>
    </thead>
    <tbody>
      {#if rows}
      {#each $rows as item}
        <tr id={item.id} on:click={() => {
          console.log(`Clicked client ID: ${item.id}`);
          clientItem = null;
          clientDetailsModal(item)
        }}>
          <td>{item.first}</td>
          <td>{item.last}</td>
          <td>{item.email}</td>
          <td>{formatPhone(item.phone)}</td>
          <td>{(item.min) ? formatDate(item.min): ''}</td>
        </tr>
      {/each}
      {/if}
    </tbody>
  </Datatable>
{:else}
  <Loader />
{/if}

<AddClientModal />

{#if clientItem}
<ClientDetailsModal {clientItem} />
{/if}
